import { useRef } from 'react'

import { loadBusinessData } from '@disco/state-management/actions/UserActions'

import useEventListener from 'hooks/use-event-listener'
import { useInterval } from 'hooks/use-interval'
import { useDispatch } from 'hooks/use-redux'

const RELOAD_INTERVAL_MS = 10 * 1000

/** Reloads the business every 10s and on returning to the tab, to pick up a payment made in Chargebee. */
const useReloadBusinessWhileVisible = (enabled = true): void => {
  const dispatch = useDispatch()
  const isReloading = useRef(false)

  // Chargebee doesn't tell the page about payment, and checkout may finish in another tab or device
  const reloadBusiness = async () => {
    // overlapping requests could let an older response overwrite a newer one
    if (!enabled || document.hidden || isReloading.current) return
    isReloading.current = true
    try {
      await dispatch(loadBusinessData('WITHOUT_REALTIME_TRACK_COUNT'))
    } finally {
      isReloading.current = false
    }
  }
  useInterval(reloadBusiness, enabled ? RELOAD_INTERVAL_MS : null)
  // not window focus: that also fires on every click back out of Chargebee's iframe
  useEventListener('visibilitychange', reloadBusiness, document)
}

export default useReloadBusinessWhileVisible
